module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/youtube.25c7ace8.svg";